<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <div class="allLoadedTxt">
    <span>{{text || $t('NoMore')}}</span>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/variable'
@import '~common/stylus/base'
.allLoadedTxt{
  @extend .flex-center;
  @extend .hs-font-caption-1;
  width: 100%;
  height: 66px;
  padding: 16px 16px 24px 16px;
  color: @color_black_300;
  text-align: center;
  >span{
    margin: 0 8px;
  }
  &:before, &:after{
    display: inline-flex;
    content: ' ';
    width: 20px;
    height: 0.5px;
    background-color: $color_black_300;
  }
}
</style>
